import {AfterViewInit, ComponentRef, Directive, ElementRef, Input, ViewContainerRef} from '@angular/core';
import {ExpandableBlockFooterComponent} from "../atoms/expandable-block-footer/expandable-block-footer.component";
import {ScrollTriggerService} from "../services/scroll-trigger.service";
import {has} from "lodash";

@Directive({
  selector: '[brtExpandableBlock]'
})
export class ExpandableBlockDirective implements AfterViewInit{
  // USAGE: apply directive for parent component, add child node with content
  @Input('max-height') maxHeight = 20; // rem

  @Input('allow-short-back') allowShortBack = true;

  @Input('viewport') viewport: "mobile" | "desktop" | "all" = "all"

  footerButton!: ComponentRef<ExpandableBlockFooterComponent>;

  constructor(private el: ElementRef, private vcr: ViewContainerRef, private stService: ScrollTriggerService) { }

  ngAfterViewInit() {

    if(this.viewport === "all" || (this.viewport === "desktop" && window.innerWidth >= 992) || (this.viewport === "mobile" && window.innerWidth < 992)) {
      const htmlEl = this.el.nativeElement as HTMLElement;
      htmlEl.classList.add("expandable-block");


      const hasOverflow = this.cutBlock();
      if(hasOverflow) {
        this.footerButton = this.vcr.createComponent(ExpandableBlockFooterComponent);
        this.footerButton.changeDetectorRef.detectChanges();
        htmlEl.appendChild(this.footerButton.location.nativeElement);
      }

      this.stService.updateTriggers();


      // console.log(htmlEl.querySelector(".expandable-block-footer__button"));
      htmlEl.querySelector(".expandable-block-footer__button")?.addEventListener("click", () => {
        if(htmlEl.classList.contains("short-back")) {
          const hasOverflow = this.cutBlock();
          htmlEl.classList.remove("short-back");
          htmlEl.classList.add("short");
          this.footerButton.setInput("title", "Mehr anzeigen");


        } else {
          htmlEl.style.height = "auto";
          htmlEl.style.overflow = "visible";
          htmlEl.classList.remove("short");

          if(this.allowShortBack) {
            htmlEl.classList.add("short-back");
            this.footerButton.setInput("title", "Weniger anzeigen");
          }
        }

        this.stService.updateTriggers();


      });
    }
  }

  cutBlock(): boolean {
    const htmlEl = this.el.nativeElement as HTMLElement;
    const root = window.document.documentElement;
    const rootFZ = parseFloat(getComputedStyle(root).fontSize);
    const maxHeightPx = this.maxHeight * rootFZ;
    if(htmlEl.offsetHeight > maxHeightPx) {
      htmlEl.classList.add("short");
      htmlEl.style.height = `${this.maxHeight}rem`;
      htmlEl.style.overflow = "hidden";
      return true;
    }
    return false;
  }


}
